import api from "@/lib/api";
import { consentFor } from "@/lib/analytics";

// Single entry point for Meta Pixel calls: consent check, standard vs custom, dedupe by eventID, dry-run outside production.
const STANDARD = new Set(["PageView", "ViewContent", "CompleteRegistration", "Lead", "Schedule"]);
const SENT_KEY = "sq_px_sent";
const PROD_HOST = /(^|\.)snap-quote\.app$/;

export const isLive = () => {
  try { return PROD_HOST.test(window.location.hostname) || localStorage.getItem("sq_px_live") === "1"; } catch { return false; }
};
export const canTrack = () => consentFor("ads");

const sentIds = () => {
  try { return JSON.parse(localStorage.getItem(SENT_KEY) || "[]"); } catch { return []; }
};
const remember = (id) => {
  try { localStorage.setItem(SENT_KEY, JSON.stringify([...sentIds().filter((x) => x !== id), id].slice(-200))); } catch {}
};

export function metaTrack(name, params = {}, eventId) {
  try {
    if (!canTrack()) { return false; }
    if (eventId && sentIds().includes(eventId)) { return false; }
    const method = STANDARD.has(name) ? "track" : "trackCustom";
    const opts = eventId ? { eventID: eventId } : undefined;
    if (isLive()) {
      if (typeof window.fbq !== "function") { return false; }
      window.fbq(method, name, params, opts);
    } else {
      (window.__sqPixel = window.__sqPixel || []).push({ method, name, params, eventId: eventId || null });
      console.info("[meta-pixel dry-run]", method, name, params, opts || "");
    }
    if (eventId) { remember(eventId); }
    return true;
  } catch { return false; }
}

const CAT = { casa: "ristrutturazione_completa", "casa completa": "ristrutturazione_completa", "camera da letto": "camera", "esterni e terrazzi": "esterni" };
export const category = (v) => { const k = String(v || "altro").toLowerCase(); return CAT[k] || k; };

let flushing = false;
// Delivers server-confirmed events (render result, registration, appointment) once, then acknowledges them.
export async function flushPixelQueue() {
  if (flushing || !canTrack()) { return; }
  flushing = true;
  try {
    const { data } = await api.get("/casa/pixel/pending");
    const ids = data.items.filter((e) => metaTrack(e.name, e.params, e.event_id) || sentIds().includes(e.event_id)).map((e) => e.event_id);
    if (ids.length) { await api.post("/casa/pixel/ack", { ids }); }
  } catch {} finally { flushing = false; }
}
